/**
 * TASK TL6. Mirrors forever-storybooks-service
 * src/modules/personalization/validators/child-name.validator.ts (S82,
 * CHILD_NAME_INVALID_CHARACTERS) exactly, so the client never refuses a name the server would
 * accept. The agreement is proved, not assumed — see scripts/verify-child-name.js, whose table
 * was generated by running the real service function in a Node one-off (ts-node, service repo,
 * never copied here).
 *
 * The allowed set is \p{L}\p{M}, space, hyphen, period, and BOTH apostrophe forms. The service
 * accepts the typographic right single quotation mark (U+2019) alongside the straight one
 * (U+0027) because iOS/Android smart-punctuation autocorrects a typed ' to ' by default — a name
 * like "O'Brien" typed on a phone arrives curly, and refusing it would reject real input over a
 * platform autocorrect choice nobody here controls. This file does not trim: leading/trailing
 * spaces are themselves allowed characters under this pattern, exactly as the service treats
 * them (see the "leading/trailing spaces" rows in the agreement table) — any trimming is a
 * decision for the caller, not this rule.
 *
 * "Visible characters" is counted by grapheme cluster (Intl.Segmenter), not UTF-16 code units
 * or codepoints, matching the service's own Intl.Segmenter count — a combining-mark name must
 * count its base letter + mark as ONE character. Intl.Segmenter has shipped in every evergreen
 * browser for years; the Array.from fallback below only matters on a browser old enough to lack
 * it, and only under-collapses a rare combining-mark sequence — an accepted approximation, since
 * the server is still the authoritative, final gate (see Requirement 3 handling in
 * product-photo-upload-modal.js).
 */
(function () {
  var MIN_VISIBLE_CHARS = 1;
  var MAX_VISIBLE_CHARS = 40;
  var ALLOWED_PATTERN = /^[\p{L}\p{M}'’\x2D\x2E\x20]+$/u;
  var MESSAGE = "Please use letters only (spaces, - ' . are fine), up to 40 characters.";

  var segmenter = (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function')
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

  function countVisibleCharacters(value) {
    if (segmenter) {
      return [...segmenter.segment(value)].length;
    }
    return Array.from(value).length;
  }

  function isValidChildName(value) {
    if (typeof value !== 'string') {
      return false;
    }

    var normalized = value.normalize('NFC');

    if (!ALLOWED_PATTERN.test(normalized)) {
      return false;
    }

    var visibleLength = countVisibleCharacters(normalized);

    return visibleLength >= MIN_VISIBLE_CHARS && visibleLength <= MAX_VISIBLE_CHARS;
  }

  window.ChildNameRule = {
    MIN_VISIBLE_CHARS: MIN_VISIBLE_CHARS,
    MAX_VISIBLE_CHARS: MAX_VISIBLE_CHARS,
    ALLOWED_PATTERN: ALLOWED_PATTERN,
    MESSAGE: MESSAGE,
    countVisibleCharacters: countVisibleCharacters,
    isValidChildName: isValidChildName
  };
})();
